import { render, staticRenderFns } from "./bsp-image.vue?vue&type=template&id=3fc884ff&scoped=true&"
import script from "./bsp-image.vue?vue&type=script&lang=js&"
export * from "./bsp-image.vue?vue&type=script&lang=js&"
import style0 from "./bsp-image.vue?vue&type=style&index=0&id=3fc884ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc884ff",
  null
  
)

export default component.exports